module.exports = __webpack_public_path__ + "static/media/QR.94b410e5.png";